module.exports = __webpack_public_path__ + "img/weather30.964ffb08.png";